import React, { FC } from 'react';
import { WithStyle } from '../../utils';
import { InputGroupStyled, InputGroupAddonStyled, InputGroupBlockStyled } from './input-group.styled';
import { InputGroupProps, InputGroupElementProps, InputGroupStaticProps } from './types';

export const InputGroup: FC<InputGroupProps> & InputGroupStaticProps & WithStyle = props => (
  <InputGroupStyled {...props} />
);
export const InputGroupAddon: FC<InputGroupElementProps> & WithStyle = props => <InputGroupAddonStyled {...props} />;
export const InputGroupBlock: FC<InputGroupElementProps> & WithStyle = props => <InputGroupBlockStyled {...props} />;

InputGroup.defaultProps = {
  $size: 'md',
};

InputGroup.displayName = 'InputGroup';
InputGroup.Style = InputGroupStyled;

InputGroup.Addon = InputGroupAddon;
InputGroupAddon.displayName = 'InputGroup.Addon';
InputGroupAddon.Style = InputGroupAddonStyled;

InputGroup.Block = InputGroupBlock;
InputGroupBlock.displayName = 'InputGroup.Block';
InputGroupBlock.Style = InputGroupBlockStyled;
